interface IconProps {
  color?: string
}

export const UploadFile = ({ color }: IconProps) => {
  return (
    <svg
      width="21"
      height="25"
      aria-hidden="true"
      viewBox="0 0 21 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.53333C0 1.58193 1.58193 0 3.53333 0H11.7621C12.6992 0 13.5979 0.372259 14.2605 1.03489L19.3651 6.13946C20.0277 6.80209 20.4 7.70081 20.4 8.6379V14.2C20.4 14.6786 20.012 15.0667 19.5333 15.0667C19.0547 15.0667 18.6667 14.6786 18.6667 14.2V9.73333H14.2C12.2486 9.73333 10.6667 8.15141 10.6667 6.2V1.73333H3.53333C2.53922 1.73333 1.73333 2.53922 1.73333 3.53333V20.8667C1.73333 21.8608 2.53922 22.6667 3.53333 22.6667H10.8667C11.3453 22.6667 11.7333 23.0547 11.7333 23.5333C11.7333 24.012 11.3453 24.4 10.8667 24.4H3.53333C1.58193 24.4 0 22.8181 0 20.8667V3.53333ZM12.4 1.85016V6.2C12.4 7.19411 13.2059 8 14.2 8H18.5498C18.4604 7.76394 18.3214 7.54706 18.1395 7.36511L13.0349 2.26054C12.8529 2.07859 12.6361 1.93962 12.4 1.85016ZM15.5465 14.6667C15.782 14.6667 16.0073 14.7625 16.1707 14.9321L20.024 18.9321C20.3561 19.2768 20.3458 19.8254 20.0011 20.1575C19.6564 20.4896 19.1077 20.4793 18.7757 20.1346L16.4 17.6685V23.5333C16.4 24.012 16.0119 24.4 15.5333 24.4C15.0546 24.4 14.6666 24.012 14.6666 23.5333V17.6959L12.3173 20.1346C11.9853 20.4793 11.4366 20.4896 11.0919 20.1575C10.7472 19.8254 10.7369 19.2768 11.069 18.9321L14.9223 14.9321C15.0857 14.7625 15.311 14.6667 15.5465 14.6667Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
